import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { PublicLayout } from "@/components/website/PublicLayout";
import { PublicNav } from "@/components/website/PublicNav";
import { PublicFooter } from "@/components/website/PublicFooter";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    Sentry.captureMessage(`404: ${location.pathname}`, "info");
  }, [location.pathname]);

  return (
    <PublicLayout className="min-h-screen bg-background flex flex-col">
      <PublicNav />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-6 text-xl text-muted-foreground">Oops! Page not found</p>
          <Link
            to="/packages"
            className="text-primary underline hover:text-primary/90"
          >
            Browse our catering packages
          </Link>
        </div>
      </main>
      <PublicFooter />
    </PublicLayout>
  );
};

export default NotFound;
